import { request } from '../api/client'
import type { SignInResponse } from '../api/client'

/**
 * Les trois appels de la connexion au portail d'administration (migration 0078) :
 * mot de passe, puis enrôlement OU vérification. Ils vivent ici et non dans `api` : le
 * bundle client n'a pas à les porter.
 */
export interface AdminChallenge {
  step: 'enroll' | 'verify'
  challengeToken: string
  expiresAt: string
  /** Clé en Base32, rendue UNE fois, à l'enrôlement seulement. */
  secret: string | null
  otpAuthUri: string | null
}

export interface AdminSession {
  session: SignInResponse
  /** Rendus à la confirmation de l'enrôlement, une seule fois ; vides ensuite. */
  recoveryCodes: string[]
}

export const adminApi = {
  signIn: (email: string, password: string) =>
    request<AdminChallenge>('/api/v1/auth/admin/sign-in', { method: 'POST', body: { email, password } }),

  enroll: (challengeToken: string, code: string) =>
    request<AdminSession>('/api/v1/auth/admin/enroll', { method: 'POST', body: { challengeToken, code } }),

  verify: (challengeToken: string, input: { code?: string; recoveryCode?: string }) =>
    request<AdminSession>('/api/v1/auth/admin/verify', {
      method: 'POST',
      body: { challengeToken, code: input.code ?? null, recoveryCode: input.recoveryCode ?? null },
    }),
}
